import type { Job } from "@domain/CRM/job";
import type { Filter } from "@ports/api/common";
import type { IJobs } from "@ports/jobs/IJobs";

export interface JobsListUseCasesDeps {
	jobsApi: IJobs;
}

/**
 * Read path for the jobs list (JobsDashboardTable). Thin pass-through to the
 * `IJobs` port; no business logic. Exists so VMs depend on a use case rather
 * than `API.Data.Jobs` directly — swap-in test/CLI implementations just supply
 * the port.
 */
export interface JobsListUseCases {
	loadByFilter(filter: Filter<Job>): Promise<Job[]>;
}

export function loadByFilter(deps: JobsListUseCasesDeps, filter: Filter<Job>): Promise<Job[]> {
	return deps.jobsApi.getByFilter(filter);
}

export function makeJobsListUseCases(deps: JobsListUseCasesDeps): JobsListUseCases {
	return {
		loadByFilter: (filter) => loadByFilter(deps, filter),
	};
}
